var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5.833,
    height: 10,
    viewBox: "0 0 5.833 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1642",
    "data-name": "\\u9577\\u65B9\\u5F62 1642",
    width: 5.833,
    height: 10,
    fill: "#172b4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_661",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 661",
    transform: "translate(5.833 10) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_661-2",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 661",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    "data-name": "\\u30D1\\u30B9 190",
    d: "M.693,10A.684.684,0,0,1,.2,9.791.732.732,0,0,1,.2,8.78L3.872,5,.2,1.219A.732.732,0,0,1,.2.208a.683.683,0,0,1,.982,0L5.833,5,1.184,9.791A.684.684,0,0,1,.693,10",
    transform: "translate(0 0)",
    fill: "#172b4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.485fe77153825145030c5058822a9842.svg";
export { ForwardRef as ReactComponent };